export default __webpack_public_path__ + "static/media/GiftIt.f10fa75aa854ec07c3124ab25f6d9d25.webp";